import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../css/Progress.module.css'; // Import CSS Module
import BottomTab from './BottomTab';
import HeaderBar from '../components/HeaderBar';

const Progress = () => {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const [error, setError] = useState('');

	const fetchAgentID = () => localStorage.getItem('user_id');

	const fetchAcceptedBookings = async () => {
		setLoading(true);
		const agentID = fetchAgentID();
		if (!agentID) return;

		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/fetch_progress_bookings.php?agent_id=${agentID}`
			);
			const result = await response.json();

			if (result.status) {
				setBookings(result.data);
			} else {
				setBookings([]);
				setError(result.msg);
			}
		} catch (error) {
			setError('Error fetching bookings');
		} finally {
			setLoading(false);
		}
	};

	const updateBookingStatus = async (orderNumber) => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/completeBooking.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ order_number: orderNumber }),
				}
			);

			const text = await response.text();
			console.log('Response:', text);

			try {
				const result = JSON.parse(text);
				if (result.status) {
					setError('Success: ' + result.msg);
					fetchAcceptedBookings(); // Refresh the bookings after update
				} else {
					setError('Error: ' + result.msg);
				}
			} catch {
				console.error('Invalid JSON response:', text);
				setError('Server error: Invalid response format.');
			}
		} catch (error) {
			console.error('Network error:', error);
			setError('Error: Failed to update booking status');
		}
	};

	const cancelBook = async (orderNumber) => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/cancel_booking.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ order_number: orderNumber }),
				}
			);
			const result = await response.json();
			setError(result.msg);
			if (result.status) fetchAcceptedBookings();
		} catch (error) {
			setError('Failed to update booking status');
		}
	};

	useEffect(() => {
		fetchAcceptedBookings();
	}, []);

	return (
		<div className={styles.container}>
			<HeaderBar title={'In Progress'} />
			{loading ? (
				<div className={styles.loader}></div>
			) : (
				<div className={styles.list}>
					<p>{error}</p>
					{bookings.map((item) => (
						<div key={item.order_number} className={styles.card}>
							<p className={styles.date}>
								{new Date(item.date).toLocaleDateString('en-GB')}
							</p>
							<h2 className={styles.orderNumber}>
								Order #: {item.order_number}
							</h2>
							<p className={styles.status}>{item.status}</p>

							<div className={styles.details}>
								<h3>Customer Details</h3>
								<p>{item.name}</p>
								<p>{item.phone}</p>
								<p>{item.email}</p>
								<p>{item.service}</p>
								<p>{item.location}</p>
								<p>{item.message}</p>
							</div>

							<div className={styles.buttonGroup}>
								<button
									className={styles.viewInvoice}
									onClick={() => navigate(`/invoices/${item.order_number}`)}
								>
									View Invoice
								</button>
								<button
									className={styles.addInvoice}
									onClick={() => navigate(`/add-invoice/${item.order_number}`)}
								>
									Add Invoice
								</button>
							</div>
							<button
								className={styles.completeButton}
								onClick={() => updateBookingStatus(item.order_number)}
							>
								Completed
							</button>
							<button
								className={styles.completeButton}
								onClick={() => cancelBook(item.order_number)}
							>
								Cancel Booking
							</button>
						</div>
					))}
				</div>
			)}
			<BottomTab />
		</div>
	);
};

export default Progress;
